import { MENUITEMS_SERVICE } from "@/services/menuItems.service.js";

const state = {getMenuItemsOutput: {}, postMenuItemOutput: false, putMenuItemOutput: false, getMenuItemDetailsOutput: {}, deleteMenuItemOutput: false};

const actions = {
    //Service to get menu items
    getMenuItems({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getMenuItemsRequest');

        MENUITEMS_SERVICE.getMenuItems(queryParams)
            .then(
                output => {
                    commit('getMenuItemsSuccess', output);
                },
                error => {
                    commit('getMenuItemsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to create menu item
    postMenuItem({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postMenuItemRequest');

        MENUITEMS_SERVICE.postMenuItem(input)
            .then(
                output => {
                    commit('postMenuItemSuccess', output);
                },
                error => {
                    commit('postMenuItemFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update menu item
    putMenuItem({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putMenuItemRequest');

        MENUITEMS_SERVICE.putMenuItem(input)
            .then(
                output => {
                    commit('putMenuItemSuccess', output);
                },
                error => {
                    commit('putMenuItemFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get menu item details
    getMenuItemDetails({ dispatch, commit }, uniqueIdentifier) {
        dispatch('alert/clear', null, { root: true });
        commit('getMenuItemDetailsRequest');

        MENUITEMS_SERVICE.getMenuItemDetails(uniqueIdentifier)
            .then(
                output => {
                    commit('getMenuItemDetailsSuccess', output);
                },
                error => {
                    commit('getMenuItemDetailsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete menu item
    deleteMenuItem({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteMenuItemRequest');

        MENUITEMS_SERVICE.deleteMenuItem(id)
            .then(
                output => {
                    commit('deleteMenuItemSuccess', output);
                },
                error => {
                    commit('deleteMenuItemFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getMenuItems
    getMenuItemsRequest(state) {
    },
    getMenuItemsSuccess(state, output) {
        state.getMenuItemsOutput = output;
    },
    getMenuItemsFailure(state) {
        state.getMenuItemsOutput = false;
    },

    //postMenuItem
    postMenuItemRequest(state) {
        state.postMenuItemOutput = null;
    },
    postMenuItemSuccess(state, output) {
        state.postMenuItemOutput = true;
    },
    postMenuItemFailure(state) {
        state.postMenuItemOutput = false;
    },

    //putMenuItem
    putMenuItemRequest(state) {
        state.putMenuItemOutput = null;
    },
    putMenuItemSuccess(state, output) {
        state.putMenuItemOutput = true;
    },
    putMenuItemFailure(state) {
        state.putMenuItemOutput = false;
    },

    //getMenuItemDetails
    getMenuItemDetailsRequest(state) {
    },
    getMenuItemDetailsSuccess(state, output) {
        state.getMenuItemDetailsOutput = output;
    },
    getMenuItemDetailsFailure(state) {
        state.getMenuItemDetailsOutput = false;
    },

    //deleteMenuItem
    deleteMenuItemRequest(state) {
        state.deleteMenuItemOutput = null;
    },
    deleteMenuItemSuccess(state, output) {
        state.deleteMenuItemOutput = true;
    },
    deleteMenuItemFailure(state) {
        state.deleteMenuItemOutput = false;
    },
};

export const menuItems = {
    namespaced: true,
    state,
    actions,
    mutations
};
